// extracted by mini-css-extract-plugin
export default {"form-lede":"tenant-entry_form-lede__gg5aA","tooltip":"tenant-entry_tooltip__Y4F+T"};